import React from 'react';
import { Box, Card, Flex } from '@legion-ui/core';
import Button from '../Button';
import Indicator from '../Indicator';
import { ModalType } from '@/store/modal';
import { MdClose } from 'react-icons/md';

interface UserRoleCardProps {
  title: string;
  description: string;
  status: 'Allowed' | 'Prohibited' | 'Unverified';
  modalType: ModalType;
  isEditButtonDisabled?: boolean;
  toggleModal: (type: ModalType) => void;
  handleOnClose?: () => void;
  isShow?: boolean;
}

const UserRoleCard: React.FC<UserRoleCardProps> = ({
  title,
  description,
  status,
  modalType,
  toggleModal,
  isEditButtonDisabled,
  handleOnClose,
  isShow,
}) => {
  return (
    <Card
      className="w-full sm:w-[18rem] flex flex-col justify-between min-h-[13rem]"
      bordered
      footer={
        <Flex alignX="flex-end">
          <Button
            variant="outline"
            size="sm"
            className="items-end"
            onClick={() => toggleModal(modalType)}
            disabled={isEditButtonDisabled}
          >
            <span className="text-black">Edit</span>
          </Button>
        </Flex>
      }
    >
      <Box className="flex-1">
        <Box alignX="center" pb="1rem">
          <Flex alignX="space-between" alignY="center">
            <Flex alignX="flex-start" alignY="center" className="space-x-2">
              <h1 className="text-base font-light lg:text-lg">{title}</h1>
              <Indicator status={status} />
            </Flex>
            {/* {isShow && (
              <Flex alignX="flex-end">
                <MdClose
                  size={22}
                  className="cursor-pointer"
                  onClick={handleOnClose}
                  color="#151718"
                />
              </Flex>
            )} */}
          </Flex>
        </Box>
        <span className="text-xs lg:text-sm">{description}</span>
      </Box>
    </Card>
  );
};

export default UserRoleCard;
